import { on } from 'delegated-events';
import invisibleFocus from '../utils/invisibleFocus';

on('mousedown', ':link, button', (event) => {
  invisibleFocus(event.currentTarget);
});
